import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { nsa } from '../models/nsa';
import { nsaBenefits } from '../models/nsa';
const HIGHLIGHT = 'Network Spinal Analysis';
function highlightNsa(text) {
    const parts = text.split(HIGHLIGHT);
    return parts.map((part, index) => (_jsxs(React.Fragment, { children: [part, index < parts.length - 1 && (_jsx("span", { className: "nsa-benefit-term", children: HIGHLIGHT }))] }, index)));
}
const NSAWidget = () => {
    return (_jsxs("div", { className: "nsa-widget", children: [nsa.map((nsa) => (_jsxs("div", { children: [_jsx("h2", { children: nsa.title }), _jsx("p", { children: highlightNsa(nsa.description) })] }, nsa.id))), nsaBenefits.map((nsaBenefits) => (_jsxs("div", { children: [_jsx("h2", { children: nsaBenefits.secondTitle }), _jsx("ul", { children: nsaBenefits.list.map((item) => {
                            const colonIndex = item.indexOf(':');
                            if (colonIndex === -1) {
                                return _jsx("li", { children: item }, item);
                            }
                            const term = item.slice(0, colonIndex);
                            const description = item.slice(colonIndex + 1).trim();
                            return (_jsxs("li", { children: [_jsx("span", { className: "nsa-benefit-term", children: term }), ": ", description] }, item));
                        }) })] }, nsaBenefits.id)))] }));
};
export default NSAWidget;
